import { cn } from '@/components/ui/cn';
import { Text, type TextProps } from '@/components/ui/Text';

/** Bakes `font-sans`; size/color are passed per call. */
export const Body = (p: TextProps) => (
  <Text variant="none" {...p} className={cn('font-sans', p.className)} />
);
